import { Lightning as lng, Utils } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';
import { GuideProgram } from './GuideProgram';

const _constants = {
  channelInfoWidth: 322,
  channelInfoFadeLength: 80,
  channelInfoMargin: 2,
  channelInfoNumber: 110,
  channelHeight: 80,
  channelInfoLogoHeight: 76,
  channelInfoLogoPos: 233,
  channelInfoLogoMaxWidth: 160,
  iconSize: 36,
};

export class GuideChannelDummy extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: _constants.channelHeight,
      ChannelInfo: {
        h: h => h,
        w: _constants.channelInfoWidth - _constants.channelInfoMargin,
        // rect: true,
        // color: Theme.Colors.Transparent,
        Background: {
          // TODO: change fade out
          w: w => w,
          h: h => h,
          Fade: {
            w: _constants.channelInfoFadeLength,
            h: h => h,
            rect: true,
            colorRight: Theme.Colors.Guide.background,
            colorLeft: Theme.Colors.Transparent,
          },
          Full: {
            x: _constants.channelInfoFadeLength,
            w: w => w - _constants.channelInfoFadeLength,
            h: h => h,
            rect: true,
            color: Theme.Colors.Guide.background,
          },
        },
        FavoriteIcon: {
          x: 0,
          mountY: 0.5,
          y: h => h / 2,
          w: _constants.iconSize,
          h: _constants.iconSize,
          src: Utils.asset('images/favorites/ic_star_open.png'),
        },
        ChannelNumber: {
          mount: 0.5,
          x: _constants.channelInfoNumber,
          y: h => h / 2,
          // h: h => h,
          // w: 150,
          text: {
            ...Theme.Fonts.Guide.ChannelNumber,
            text: '',
          },
        },
        ChannelLogo: {
          mountX: 0.5,
          mountY: 0.5,
          x: _constants.channelInfoLogoPos,
          y: _constants.channelHeight / 2,
          h: _constants.channelInfoLogoHeight,
          texture: {
            type: lng.textures.ImageTexture,
            src: '',
            resizeMode: {
              type: 'contain',
              w: _constants.channelInfoLogoMaxWidth,
              h: _constants.channelInfoLogoHeight,
            },
          },
        },
      },
      ProgramContainer: {
        x: _constants.channelInfoWidth,
        w: w => w - _constants.channelInfoWidth,
        h: h => h,
        Dummy: {
          type: GuideProgram,
          w: w => w,
        },
      },
    };
  }

  _getFocused() {
    return this.tag('ProgramContainer').childList.first;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  moveRight() {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  moveLeft() {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCategories() {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setTime() {}

  _active() {
    this.signal('loadNext');
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  _inactive() {}

  getCurrentPosition() {
    return 0;
  }

  setPreferedFocus() {
    return;
  }
}
